'use strict';

// TODO: Use modernizr!
const deviceCapabilities = [
  function () {

    function detectTransformProperty() {
      let transformProperty = 'transform';
      const safariPropertyHack = 'webkitTransform';

      if (typeof document.body.style[transformProperty] !== 'undefined') {

        ['webkit', 'moz', 'o', 'ms'].every(function (prefix) {
          let e = `-${prefix}-transform`;

          if (typeof document.body.style[e] !== 'undefined') {
            transformProperty = e;
            return false;
          }
          return true;
        });
      } else if (typeof document.body.style[safariPropertyHack] !== 'undefined') {
        transformProperty = '-webkit-transform';
      } else {
        transformProperty = undefined;
      }
      return transformProperty;
    }

    function detect3dSupport() {
      const el = document.createElement('p');
      const transforms = {
        'webkitTransform': '-webkit-transform',
        'msTransform': '-ms-transform',
        'transform': 'transform'
      };
      let has3d;

      // Add it to the body to get the computed style
      document.body.insertBefore(el, null);
      for (let t in transforms) {
        if (el.style[t] !== undefined) {
          el.style[t] = 'translate3d(1px,1px,1px)';
          has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
        }
      }
      document.body.removeChild(el);
      return (has3d !== undefined && has3d.length > 0 && has3d !== 'none');
    }

    function getPixelRatio() {
      var ratio = 1;

      if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
        ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
      } else if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      }
      return ratio;
    }

    function isIOSDevice() {
      return  navigator.userAgent.match(/iPad|iPhone|iPod/i) != null;
    }

    return {
      transformProperty: detectTransformProperty(),
      has3d: detect3dSupport(),
      pixelRatio: getPixelRatio(),
      isIOSDevice: isIOSDevice()
    };
  }
];

export default deviceCapabilities;



// WEBPACK FOOTER //
// ./app/src/services/device_capabilities.js